import { Percentage } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconPercentage12Line = createIcon(Percentage, 12, "Line");
export const IconPercentage16Line = createIcon(Percentage, 16, "Line");
export const IconPercentage20Line = createIcon(Percentage, 20, "Line");
export const IconPercentage24Line = createIcon(Percentage, 24, "Line");
export const IconPercentage32Line = createIcon(Percentage, 32, "Line");
export const IconPercentage48Line = createIcon(Percentage, 48, "Line");
export const IconPercentage64Line = createIcon(Percentage, 64, "Line");
